<template>
  <div class="modal-wrapper">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button class="close"
                  @click="$emit('close')"
                  aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Desconto
          </h4>
        </div>

        <div class="modal-body">
          <div class="modal-body__field">
            <label class="modal-body__field-label">Tipo</label>
            <select @click="errorMessage = null" v-model="kind" class="form-control" :disabled="!toCreate()">
              <option value="null" disabled>
                Informe o tipo do desconto
              </option>
              <option v-for="(discountKind, index) in kinds" :value="discountKind.value" :key="index">
                {{ discountKind.label }}
              </option>
            </select>
          </div>
          <div class="modal-body__field">
            <label class="modal-body__field-label">Data de expiração</label>
            <date-picker v-model="expiryDate"
                         placeholder="Informe a data de expiração, se houver"
                         :config="datePickerOptions"
                         :disabled="toDisable()"
            />
          </div>
          <div class="modal-body__field">
            <label class="modal-body__field-label">Valor</label>
            <money v-bind="moneyOptions"
                   class="form-control"
                   v-model="amount"
                   :disabled="toDisable()"
                   @click="errorMessage = null"
            />
          </div>

          <div v-if="errorMessage" class="alert alert-danger">
            {{ errorMessage }}
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn btn-primary" @click="submit()">
            {{ modalActionText }}
          </button>
          <button class="btn btn-default" @click="$emit('close')">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { Money } from 'v-money';
import DatePicker from 'vue-bootstrap-datetimepicker';
import DiscountsService from 'services/DiscountsService';
import moment from 'moment';
import datePickerOptions from 'utils/DatePickerOptions';
import moneyOptions from 'utils/MoneyOptions';
import 'moment/locale/pt-br';

export default {
  data() {
    return {
      amount: 0.0,
      errorMessage: null,
      expiryDate: null,
      kind: null,
      kinds: [],
      datePickerOptions,
      moneyOptions,
    };
  },
  components: {
    DatePicker,
    Money,
  },
  created() {
    this.loadKinds();
    if (this.selectedDiscount.amount) this.amount = this.selectedDiscount.amount;
    if (this.selectedDiscount.kind) this.kind = this.selectedDiscount.kind;
    if (this.selectedDiscount.expiry_date) {
      this.expiryDate = moment(this.selectedDiscount.expiry_date).format('DD/MM/YYYY');
    }
  },
  computed: {
    ...mapState([
      'selectedDiscount',
    ]),
    modalActionText() {
      if (this.toCreate()) return 'Criar';
      if (this.toDisable()) return 'Desativar';
      if (this.discountAction() === 'edit') return 'Editar';

      return 'Editar e reativar';
    },
  },
  methods: {
    loadKinds() {
      DiscountsService.enums()
        .then((body) => { this.kinds = body.kinds; })
        .catch(() => {
          this.$emit('close');
          this.$alert.notifyAlert('Não foi possível carregar os tipos de desconto');
        });
    },
    discountAction() {
      if (!this.selectedDiscount.id) return 'create';
      if (this.selectedDiscount.disable) return 'disable';
      if (this.selectedDiscount.enabled) return 'edit';

      return 'reactivate';
    },
    isAdvancedPayment() {
      return this.kind === 'advanced_payment';
    },
    toCreate() {
      return this.discountAction() === 'create';
    },
    toDisable() {
      return this.discountAction() === 'disable';
    },
    toUpdate() {
      return this.discountAction() === 'edit' || this.discountAction() === 'reactivate';
    },
    submit() {
      this.validate();

      if (this.errorMessage) return;

      if (this.toCreate()) {
        this.create();
      } else if (this.toDisable()) {
        this.disable();
      } else if (this.toUpdate()) {
        this.update();
      } else {
        this.$emit('close');
        this.$alert.notifyAlert('Erro inesperado');
      }
    },
    validate() {
      if ((this.toDisable() && this.selectedDiscount.id) || (this.kind && (this.amount > 0)
         && ((this.isAdvancedPayment() && this.expiryDate) || !this.isAdvancedPayment()))) {
        this.errorMessage = null;
      } else {
        this.errorMessage = 'Preencha todos os campos corretamente, apenas para desconto de pontualidade';
        this.errorMessage += ' a data de expiração é obrigatória';
      }
    },
    create() {
      this.processRequest(
        DiscountsService.create(this.selectedDiscount.bill_id, this.amount, this.expiryDate, this.kind),
        'Desconto criado',
        'Erro ao criar desconto',
      );
    },
    disable() {
      this.processRequest(
        DiscountsService.disable(this.selectedDiscount.id),
        'O desconto foi desativado',
        'Erro ao desativar desconto',
      );
    },
    update() {
      this.processRequest(
        DiscountsService.update(this.selectedDiscount.id, this.amount, this.expiryDate),
        'Desconto atualizado',
        'Erro ao atualizar desconto',
      );
    },
    processRequest(request, successMessage, errorPrefixMessage) {
      this.$loader.show();

      request
        .then(() => {
          this.$emit('close');
          this.$alert.notifySuccess(successMessage);
        })
        .catch((body) => {
          this.$alert.notifyAlert(`${errorPrefixMessage}: ${body.message}`);
        })
        .finally(() => { this.$loader.hide(); });
    },
  },
};
</script>

<style lang="scss">
  .modal-body__field {
    margin: 8px;
  }

  .modal-body__field-label {
    font-weight: 600;
  }
</style>
